/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import help from '../../../../assets/icons/help.svg';

import paymentWaitStyles from './payment-wait.styles';
import StepLoader from '../step-loader/step-loader.components';

export const PaymentWait: FC = () => {
    const intl = useIntl();
    return (
        <>
            <p css={paymentWaitStyles.description}>
                <img src={help} alt="help" />
                <span>{intl.formatMessage({ id: 'awaitingPaymentConfirmationDescription' })}</span>
            </p>
            <StepLoader />
        </>
    );
};
